import { Component, h, ComponentInterface, Prop } from "@stencil/core";
import {
  INotification,
  IThemeOptions,
  NotificationTypeEnum,
} from "../../../models";
import { store, Unsubscribe } from "@stencil/redux";
import { RootState } from "../../../store/states";
import { ThemeService } from "../../../services";
import { NotificationService } from "../../../services/notification.service";

@Component({
  tag: "av-notification-manager",
  styleUrl: "av-notification-manager.scss",
  shadow: true,
})
export class AvNotificationManager implements ComponentInterface {
  @Prop() offset: boolean = false;

  @Prop({ mutable: true }) $notifications: { [id: string]: INotification };

  themeOptions: IThemeOptions;
  storeUnsubscribe: Unsubscribe;
  voiceOverRef: HTMLDivElement;

  constructor() {
    ThemeService.optionsAvailable().subscribe(
      (options) => (this.themeOptions = options)
    );
  }

  connectedCallback() {
    if (this.storeUnsubscribe) this.storeUnsubscribe();

    this.storeUnsubscribe = store.mapStateToProps(
      this,
      (rootState: RootState) => {
        const {
          notifications: { items },
        } = rootState;
        return { $notifications: items };
      }
    );

    NotificationService.registerVoiceOverAnnouncer((message) => {
      !!message
        ? this.readNotification(message)
        : (this.voiceOverRef.textContent = undefined);
    });
  }

  readNotification(message: string) {
    if (!this.voiceOverRef) return;
    this.voiceOverRef.textContent = message;
  }

  disconnectedCallback(): void {
    this.storeUnsubscribe();
  }

  get isPositionLeft() {
    return this.themeOptions.positionHorizontal === "left";
  }
  get isPositionRight() {
    return this.themeOptions.positionHorizontal === "right";
  }
  get isPositionCenter() {
    return this.themeOptions.positionHorizontal === "center";
  }
  get isPositionTop() {
    return this.themeOptions.positionVertical === "top";
  }
  get isPositionBottom() {
    return this.themeOptions.positionVertical === "bottom";
  }
  get hasConfirm() {
    return Object.keys(this.$notifications)
      .map((key) => this.$notifications[key])
      .some((n) => n.type === NotificationTypeEnum.confirm);
  }

  render() {
    const items = [];
    for (let key in this.$notifications) {
      if (key in this.$notifications) {
        const n = this.$notifications[key];
        items.push(
          <av-notification key={n.id} notification={n}></av-notification>
        );
      }
    }
    return (
      <div
        class={{
          "av-notification-manager": true,
          "av-notification-manager-offset": this.offset && !this.hasConfirm,
          "av-notification-manager-left": this.isPositionLeft,
          "av-notification-manager-right": this.isPositionRight,
          "av-notification-manager-center": this.isPositionCenter,
          "av-notification-manager-top": this.isPositionTop,
          "av-notification-manager-bottom": this.isPositionBottom,
        }}
      >
        <div
          ref={(e) => (this.voiceOverRef = e)}
          aria-live="polite"
          role="alert"
          class="av-notification-manager-voice"
        ></div>
        {items}
      </div>
    );
  }
}
